module.exports = __webpack_public_path__ + "static/assets/86bb825751108ceb583152c13625534b.svg";